import { motion } from "framer-motion";

const txtVariant = {
  initial: {
    y: "100%",
  },
  animate: {
    y: 0,
    transition: {
      ease: [0.6, 0.01, -0.05, 0.95],
      duration: 1.5,
    },
  },
};

const imgVariant = {
  initial: {
    clipPath: "inset(100px 50px)",
  },
  animate: {
    clipPath: "inset(0px)",
    transition: {
      ease: [0.6, 0.01, -0.05, 0.95],
      duration: 1.8,
    },
  },
};

export default function Home() {
  return (
    <div className="main-section" id="home">
      <section className="hero">
        <div className="hero-background">
          <picture>
            <source
              srcSet="./images/hero-desktop.webp"
              media="(min-width: 800px)"
            />
            <source
              srcSet="./images/hero-mobile.webp"
              media="(min-width: 300px)"
            />
            <img
              src="./images/hero-mobile.webp"
              alt="Hero Background"
            />
          </picture>
          <div className="overlay"></div>
        </div>

        <div className="hero__content">
          <div className="overlay-div">
            <motion.h1
              variants={txtVariant}
              initial="initial"
              whileInView="animate"
              viewport={{ once: true }}
            >
              <span className="mobile">Glass<br />Alluminum <br /> Perfection</span>
              <span className="desktop">Glass<br />Alluminum <br /> Perfection</span>
            </motion.h1>
          </div>

          <div className="hero__cta-container">
            <a href="tel:+919716043891" className="hero-cta-btn">Call for Quote</a>
          </div>
        </div>
      </section>
      {/* BREAk |||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||*/}

      <section className="quote unpadded">
        <div className="subheading">
          <div className="overlay-div">
            <motion.h2
              className="one"
              variants={txtVariant}
              initial="initial"
              whileInView="animate"
              viewport={{ once: true }}
            >
              Glass
            </motion.h2>
          </div>
          <div className="overlay-div">
            <motion.h2
              className="two"
              variants={txtVariant}
              initial="initial"
              whileInView="animate"
              viewport={{ once: true }}
            >
              Alluminum
            </motion.h2>
          </div>
          <div className="overlay-div">
            <motion.h2
              className="three"
              variants={txtVariant}
              initial="initial"
              whileInView="animate"
              viewport={{ once: true }}
            >
              PIONEERS
            </motion.h2>
          </div>
        </div>

        <motion.div
          className="quote__img"
          variants={imgVariant}
          initial="initial"
          whileInView="animate"
          viewport={{ once: true }}
        >
          <img src="./images/quote.jpg" alt="" />

          <div className="overlay"></div>

          <div className="text">
            A Place where our passion shapes the beauty of your Home.
          </div>
        </motion.div>
      </section>
    </div>
  );
}
